
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-one-pager",
      function () {
        return require("private-next-pages/create-one-pager.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-one-pager"])
      });
    }
  